// imageUploader.js - carica/elimina immagini tramite il server locale (volume Docker)
import axios from 'axios';

const IMAGE_SERVER_URL = process.env.VUE_APP_IMAGE_SERVER_URL || '';

/**
 * Carica un'immagine sul server locale.
 * @param {File} selectedFile - Il file immagine da caricare
 * @returns {Promise<string>} URL pubblico dell'immagine caricata
 */
function uploadImage(selectedFile) {
  return new Promise((resolve, reject) => {
    if (!selectedFile) {
      reject("Seleziona un'immagine prima di caricarla.");
      return;
    }

    const formData = new FormData();
    formData.append('image', selectedFile);

    axios.post(`${IMAGE_SERVER_URL}/api/images/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(response => {
        resolve(response.data.url);
      })
      .catch(error => {
        reject("Errore durante il caricamento dell'immagine: " + error.message);
      });
  });
}

/**
 * Elimina un'immagine dal server locale tramite URL o filename.
 * @param {string} imageUrl - URL completo dell'immagine
 * @returns {Promise<string>}
 */
function deleteImageByUrl(imageUrl) {
  return new Promise((resolve, reject) => {
    if (!imageUrl) {
      reject("L'URL dell'immagine è vuoto.");
      return;
    }

    // Estrai il filename dall'URL
    const filename = imageUrl.split('/').pop();

    axios.delete(`${IMAGE_SERVER_URL}/api/images/delete`, {
      data: { filename }
    })
      .then(() => {
        resolve("Immagine eliminata con successo.");
      })
      .catch(error => {
        reject("Errore durante l'eliminazione dell'immagine: " + error.message);
      });
  });
}

export { uploadImage, deleteImageByUrl };
